import { render } from "./ViewCallLogsAdmin.vue?vue&type=template&id=afb4973c&scoped=true"
import script from "./ViewCallLogsAdmin.vue?vue&type=script&lang=js"
export * from "./ViewCallLogsAdmin.vue?vue&type=script&lang=js"

import "./ViewCallLogsAdmin.vue?vue&type=style&index=0&id=afb4973c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb4973c"]])

export default __exports__